import { Box, Checkbox, Icon, List, ListItem, Tooltip, Typography } from '@mui/material'
import { useState, useEffect, Dispatch, SetStateAction, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useStyles } from '../../components/access/styles'
import { removeAllReference } from '../../../../../../utils/methods/removedReference'
import { TabsChildren } from '../../components/access/utils/enums/tabs'
import { icons } from '../../../../../../utils/icons'


const useTables = ({ setUserSelected, userSelected, dataFilter, filterRow, ...props }: {
  filterRow: ({ value, list }: {
    value: Record<string, unknown>;
    list: any[];
  }) => any[]; dataFilter: Record<string, unknown>; dataUsers: { area: string; department: string; id: number; }[]; tab: string; userSelected: Record<string, boolean>; setUserSelected: Dispatch<SetStateAction<Record<string, boolean>>>, /* handleFolioSetting: (data?: Record<string, Item[]> | undefined) => void; */ userTable: { [x: string]: any }[]
}) => {
  const { t } = useTranslation()
  const styles = useStyles()
  const [openModal, setOpenModal] = useState<{
    open: boolean
    title: string
    description: string
    id: string | number
    confirm?: () => void
  }>({
    id: '',
    open: false,
    title: '',
    description: '',
  })
  const [deleteSelected, setDeletedSelected] = useState<string[]>([])
  const [usersToDelete, setUsersToDelete] = useState<number[]>([])
  const [userFolioSelected, setUserFolioSelected] = useState<
    Record<
      string,
      {
        webAccess?: boolean
        mobileAccess?: boolean
        seeReport?: boolean
        resendReport?: boolean
      }
    >
  >({})

  const setAllUsers = ({ newSelected }: { newSelected: Record<string, boolean>; }) => {
    setUserSelected(newSelected)
  }

  const closeModal = () => {
    setOpenModal((prev) => ({
      ...prev,
      open: false,
      confirm: undefined
    }))
  }

  const handleSelect = ({ id, value, name }: { id: string; value: boolean; name: 'webAccess' | 'mobileAccess' | 'seeReport' | 'resendReport' }) => {
    const opsiteName = name == 'webAccess' ? 'mobileAccess' : 'webAccess'
    if ((name == 'webAccess' || name == 'mobileAccess') && !userFolioSelected?.[id]?.[opsiteName] && !value && (!!userFolioSelected?.[id]?.seeReport || !!userFolioSelected?.[id]?.resendReport)) {
      setOpenModal((prev) => ({
        ...prev,
        open: true,
        id,
        title: t('loogbook.modal.deleteSettingsTitle'),
        description: t('loogbook.modal.deleteSettingsDescription'),
        confirm: () => {
          setUserFolioSelected((prev) => ({
            ...prev,
            [id]: {
              ...prev[id],
              [name]: value,
              seeReport: false,
              resendReport: false
            },
          }))
          closeModal()
        }
      }))
    } else {
      setUserFolioSelected((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          [name]: value,
        },
      }))
    }
  }

  const [row, setRow] = useState<
    {
      id: number | string
      name: string
      role: number | string
      roleName: number | string
      areaName: string
      departmentName: string
    }[]>([])
  const getUsersThatCanManageFolios = () => {
    let newSelectedUser: Record<
      string,
      {
        webAccess?: boolean
        mobileAccess?: boolean
        seeReport?: boolean
        resendReport?: boolean
      }
    > = structuredClone(userFolioSelected)

    const newRow: {
      id: number | string
      name: string
      role: number | string
      roleName: number | string
      areaName: string
      departmentName: string
      userType: number
    }[] = []

    Object.entries(userSelected)?.forEach(([key, item]) => {
      const user = props?.userTable?.find((itemUsers) => itemUsers.id?.toString() == key)
      const userExtraData = props?.dataUsers?.find((itemUsers) => itemUsers.id?.toString() == key)
      if (!!item && !!user) {

        if (!newSelectedUser[key]) {
          newSelectedUser = {
            ...newSelectedUser,
            [key]: {
              ...newSelectedUser[key],
              mobileAccess: false,
              resendReport: false,
              seeReport: false,
              webAccess: false
            },
          }
        } else {
          newSelectedUser = { ...newSelectedUser, [key]: newSelectedUser[key] }
        }

        newRow.push({
          id: user?.id ?? '',
          name: user?.name ?? '',
          role: user?.role ?? '',
          roleName: user?.roleName ?? '',
          areaName: userExtraData?.area ?? '',
          departmentName: userExtraData?.department ?? '',
          userType: user?.userType ?? 0
        })
      }
    })

    setRow(
      newRow?.sort((a) => {
        if (!!newSelectedUser?.[a.id]?.mobileAccess) {
          return -1
        }
        return 1
      })
    )
    setUserFolioSelected(newSelectedUser)
    setUsersToDelete(prev => prev.filter(id => !userSelected[id]))
  }

  const setAllSettingsFolioUser = (data: {
    skip?: boolean
    filter?: Record<string, any>[]
    userFolio: Record<
      string,
      {
        webAccess?: boolean
        mobileAccess?: boolean
        seeReport?: boolean
        resendReport?: boolean
      }
    >
  }) => {
    setUserFolioSelected(data.userFolio)
  }
  const rowFiltered = useMemo(() => filterRow({ list: row, value: dataFilter }), [row, dataFilter])

  const headersChecks = useMemo(() => {
    const userFolioSelectedCopy = removeAllReference(userFolioSelected)
    const webAccess = rowFiltered.some(item => !userFolioSelectedCopy?.[item.id]?.webAccess)
    const mobileAccess = rowFiltered.some(item => !userFolioSelectedCopy?.[item.id]?.mobileAccess)
    const seeReport = rowFiltered.some(item => !userFolioSelectedCopy?.[item.id]?.seeReport)
    const resendReport = rowFiltered.some(item => !userFolioSelectedCopy?.[item.id]?.resendReport)

    return {
      webAccess: !webAccess && rowFiltered?.length,
      mobileAccess: !mobileAccess && rowFiltered?.length,
      seeReport: !seeReport && rowFiltered?.length,
      resendReport: !resendReport && rowFiltered?.length
    }
  }, [userFolioSelected])

  const selectOrUnSelectAll = (payload?: { name: string; value: boolean }) => {
    const { name, value } = payload || {};
    let userFolioSelectedCopy = removeAllReference(userFolioSelected)
    const oppositeName = name == 'webAccess' ? 'mobileAccess' : 'webAccess'

    if (name == 'webAccess' || name == 'mobileAccess') {
      const existSomeConfig = rowFiltered?.some((item) => (!!userFolioSelected[item.id]?.resendReport || !!userFolioSelected[item.id]?.seeReport) && !userFolioSelected[item.id]?.[oppositeName])
      if (!value && existSomeConfig) {
        setOpenModal((prev) => ({
          ...prev,
          open: true,
          title: t('loogbook.modal.deleteSettingsTitle'),
          description: t('loogbook.modal.deleteSettingsDescription'),
          confirm: () => {
            rowFiltered.forEach((item) => {
              userFolioSelectedCopy[item.id] = {
                ...userFolioSelectedCopy[item.id],
                seeReport: userFolioSelectedCopy[item.id][oppositeName] == false && value == false ? false : true,
                resendReport: userFolioSelectedCopy[item.id][oppositeName] == false && value == false ? false : true,
                [name]: false
              };
            });
            setUserFolioSelected(userFolioSelectedCopy)
            closeModal()
          }
        }))
        return
      }
    }
    if (name == 'webAccess') {
      rowFiltered.forEach(row => {
        userFolioSelectedCopy[row.id] = { ...userFolioSelectedCopy[row.id], webAccess: !!payload?.value }
      })
    }
    if (name == 'mobileAccess') {
      rowFiltered.forEach(row => {
        userFolioSelectedCopy[row.id] = { ...userFolioSelectedCopy[row.id], mobileAccess: !!payload?.value }
      })
    }
    if (name == 'seeReport') {
      rowFiltered.forEach(row => {
        const currentUser = userFolioSelectedCopy[row.id]
        userFolioSelectedCopy[row.id] = { ...userFolioSelectedCopy[row.id], seeReport: !!payload?.value && (!!currentUser.mobileAccess || !!currentUser.webAccess) }
      })
    }
    if (name == 'resendReport') {
      rowFiltered.forEach(row => {
        const currentUser = userFolioSelectedCopy[row.id]
        userFolioSelectedCopy[row.id] = { ...userFolioSelectedCopy[row.id], resendReport: !!payload?.value && (!!currentUser.mobileAccess || !!currentUser.webAccess) }
      })
    }

    setUserFolioSelected(userFolioSelectedCopy)
  }
  const deletedUsersSelecteds = (payload?: { id: string }) => {
    setOpenModal((prev) => ({
      ...prev,
      open: true,
      title: t('loogbook.modal.deleteSettingsPermission', { count: payload?.id ? 1 : 0 }),
      description: t('loogbook.modal.deletePermissionDescription'),
      confirm: () => {
        const selectUserCopy = removeAllReference(userSelected)
        const userFolioSelectedCopy = removeAllReference(userFolioSelected)
        setUsersToDelete(prev => [
          ...prev,
          ...deleteSelected
            .map(id => Number(id))
            .filter(id => !prev.includes(id))
        ]);

        if (payload?.id) {
          setRow(prev => prev.filter(item => item.id != payload.id))
          delete selectUserCopy[payload.id]
          delete userFolioSelectedCopy[payload.id]
          setUserSelected(selectUserCopy)
          setUserFolioSelected(userFolioSelectedCopy)
          setDeletedSelected(prev => prev.filter(item => item != payload.id))
          closeModal()
          return
        }
        setRow(prev => prev.filter(item => !deleteSelected.includes(item.id)))
        deleteSelected.forEach(item => {
          delete selectUserCopy[item]
          delete userFolioSelectedCopy[item]
        })
        setUserFolioSelected(userFolioSelectedCopy)
        setUserSelected(selectUserCopy)
        setDeletedSelected([])
        closeModal()
      }
    }))

  }

  const column = [
    {
      id: 'name',
      label: t('general.tags.name'),
      sortable: true,
    },
    {
      id: 'roleName',
      label: t('general.tags.role'),
      sortable: true,
    },
    {
      id: 'areaName',
      label: t('general.tags.area'),
      sortable: true,
      renderCell: (params: any) => {
        const areaArray = params.current ? params.current.split(',').map((item: string) => item.trim()) : undefined;
        const firstTwoAreas = areaArray?.slice(0, 2);
        const remainingAreas = areaArray?.slice(2);
        return (
          <Box /* sx={styles.containerStatus} */>
            <Typography sx={styles.areaTitle}>
              {firstTwoAreas?.join(', ')}
              {remainingAreas?.length > 0 && (
                <Tooltip
                  title={
                    <List>
                      {remainingAreas.map((item: string, index: number) => (
                        <ListItem key={index} style={{ padding: 0 }}>
                          {item}
                        </ListItem>
                      ))}
                    </List>
                  }
                >
                  <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                </Tooltip>
              )}
              {!areaArray && 'N/A'}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'departmentName',
      label: t('general.tags.department'),
      sortable: true,
      renderCell: (params: any) => {
        const departmentArray = params.current ? params.current.split(',').map((item: string) => item.trim()) : undefined;
        const firstTwoDepartments = departmentArray?.slice(0, 2);
        const remainingDepartments = departmentArray?.slice(2);
        return (
          <Box /* sx={styles.containerStatus} */>
            <Typography sx={styles.areaTitle}>
              {firstTwoDepartments?.join(', ')}
              {remainingDepartments?.length > 0 && (
                <Tooltip
                  title={
                    <List>
                      {remainingDepartments.map((item: string, index: number) => (
                        <ListItem key={index} style={{ padding: 0 }}>
                          {item}
                        </ListItem>
                      ))}
                    </List>
                  }
                >
                  <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                </Tooltip>
              )}
              {!departmentArray && 'N/A'}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'webAccess',
      label: t('general.tags.webAccess'),
      minWidth: 50,
      headerCell: {
        '&.header-cell.header-cell': {
          whiteSpace: 'normal'
        }
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              className='remove-m'
              name="delete"
              checked={!!headersChecks.webAccess}
              onChange={(_, check) => {
                selectOrUnSelectAll({ name: 'webAccess', value: check })
              }}
              sx={{ m: 1 }}
            />

            <Typography sx={styles.checkLabel}>
              {t('general.tags.webAccess')}
            </Typography>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="webAccess"
              /* disabled={!!userFolioSelected?.[params?.row?.id]?.status} */
              checked={!!userFolioSelected?.[params?.row?.id]?.webAccess}
              onChange={(_, check) => {
                /* if (!userFolioSelected?.[params?.row?.id]?.status) { */
                handleSelect({ id: params?.row?.id, value: check, name: 'webAccess' })
                /* } */
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    },
    {
      id: 'mobileAccess',
      label: t('general.tags.mobileAccess'),
      minWidth: 50,
      headerCell: {
        '&.header-cell.header-cell': {
          whiteSpace: 'normal'
        }
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              className='remove-m'
              name="delete"
              checked={!!headersChecks.mobileAccess}
              onChange={(_, check) => {
                selectOrUnSelectAll({ name: 'mobileAccess', value: check })
              }}
              sx={{ m: 1 }}
            />

            <Typography sx={styles.checkLabel}>
              {t('general.tags.mobileAccess')}
            </Typography>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="mobileAccess"
              /* disabled={!!userFolioSelected?.[params?.row?.id]?.status} */
              checked={!!userFolioSelected?.[params?.row?.id]?.mobileAccess}
              onChange={(_, check) => {
                /* if (!userFolioSelected?.[params?.row?.id]?.status) { */
                handleSelect({ id: params?.row?.id, value: check, name: 'mobileAccess' })
                /* } */
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    },
    {
      id: 'seeReport',
      label: t('general.seeReport'),
      minWidth: 50,
      headerCell: {
        '&.header-cell.header-cell': {
          whiteSpace: 'normal'
        }
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              className='remove-m'
              name="delete"
              checked={!!headersChecks.seeReport}
              onChange={(_, check) => {
                selectOrUnSelectAll({ name: 'seeReport', value: check })
              }}
              sx={{ m: 1 }}
            />

            <Typography sx={styles.checkLabel}>
              {t('general.seeReport')}
            </Typography>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="seeReport"
              disabled={!userFolioSelected?.[params?.row?.id]?.mobileAccess && !userFolioSelected?.[params?.row?.id]?.webAccess}
              checked={!!userFolioSelected?.[params?.row?.id]?.seeReport}
              onChange={(_, check) => {
                /* if (!userFolioSelected?.[params?.row?.id]?.status) { */
                handleSelect({ id: params?.row?.id, value: check, name: 'seeReport' })
                /* } */
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    },
    {
      id: 'resendReport',
      label: t('schedule.modal.resendReport'),
      minWidth: 50,
      headerCell: {
        '&.header-cell.header-cell': {
          whiteSpace: 'normal'
        }
      },
      column: () => {
        return (
          <Box sx={styles.all}>
            <Checkbox
              className='remove-m'
              name="delete"
              checked={!!headersChecks.resendReport}
              onChange={(_, check) => {
                selectOrUnSelectAll({ name: 'resendReport', value: check })
              }}
              sx={{ m: 1 }}
            />

            <Typography sx={styles.checkLabel}>
              {t('schedule.modal.resendReport')}
            </Typography>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.action}>
            <Checkbox
              name="resendReport"
              disabled={!userFolioSelected?.[params?.row?.id]?.mobileAccess && !userFolioSelected?.[params?.row?.id]?.webAccess}
              checked={!!userFolioSelected?.[params?.row?.id]?.resendReport}
              onChange={(_, check) => {
                /* if (!userFolioSelected?.[params?.row?.id]?.status) { */
                handleSelect({ id: params?.row?.id, value: check, name: 'resendReport' })
                /* } */
              }}
              sx={{ m: 1 }}
            />
          </Box>
        )
      },
    },
    /*     {
          id: 'settings',
          label: t('department.form.tabs.settings'),
          minWidth: 50,
          contentColumn: {
            justifyContent: 'center',
          },
          renderCell: (params: any) => {
            return (
              <Box sx={styles.setting}>
                <Tooltip title={t('department.form.table.delete')}>
                  <IconButton
                    className='delete'
                    onClick={() => { deletedUsersSelecteds({ id: params?.row?.id }) }}
                  >
                    {icons('delete')}
                  </IconButton>
                </Tooltip>
              </Box>
            )
          },
        }, */

  ]

  useEffect(() => {
    if (props.tab === TabsChildren.PERMISSIONS) {
      getUsersThatCanManageFolios()
    }

  }, [props?.tab, userSelected])

  return { userSelected, usersToDelete, rowFiltered, row, column, openModal, userFolioSelected, deleteSelected, deletedUsersSelecteds, setDeletedSelected, setUserSelected, closeModal, setAllUsers, setAllSettingsFolioUser }
}

export { useTables }
